import type { Order, Sale } from '@/types';

export function getCustomerDisplayName(order: Order): string {
  const c = order.customer;
  if (c) {
    const first = (c.firstName ?? '').trim();
    const last = (c.lastName ?? '').trim();
    if (first || last) return [first, last].filter(Boolean).join(' ');
    if (c.email) return c.email;
  }
  if (order.customerId != null) return `Customer ${order.customerId}`;
  return 'Guest Customer';
}

export function transformOrderToSale(order: Order): Sale {
  const orderItems = order.orderItems || [];
  const totalAmountFromItems = orderItems.reduce(
    (sum, item) => sum + (item?.productPriceAt || 0) * (item?.quantity || 0),
    0
  );
  const totalAmount =
    typeof order.total === 'string' && order.total.trim() !== ''
      ? parseFloat(order.total) || 0
      : totalAmountFromItems;

  const orderItemsCount = order.orderItemsCount || 0;
  const firstItem = orderItems[0];
  const firstProductName = firstItem?.product?.name;
  const firstQty = firstItem?.quantity || 0;
  const productsText =
    orderItemsCount === 1
      ? `${firstProductName ?? 'Item'} x${firstQty}`
      : `${orderItemsCount} Items`;

  const paidAt =
    typeof order.metadata === 'object' && order.metadata !== null
      ? (order.metadata as { paymentData?: { paidAt?: unknown } })?.paymentData
          ?.paidAt
      : undefined;

  const isPaid =
    order.status === 'paid' ||
    (typeof paidAt === 'string' && paidAt.length > 0);

  return {
    id: order.id?.toString() || 'unknown',
    name: getCustomerDisplayName(order),
    reference: order.reference ?? undefined,
    products: productsText,
    amount: `₦${totalAmount.toLocaleString()}`,
    status: (order.status === 'cancelled'
      ? 'Cancelled'
      : order.status === 'paid' || order.status === 'completed'
        ? 'Completed'
        : 'Pending') as 'Pending' | 'Completed' | 'Cancelled',
    payment: isPaid ? 'Paid' : 'Unpaid',
    date: order.createdAt
      ? new Date(order.createdAt).toLocaleDateString()
      : 'N/A',
  };
}
